import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/roles";

export const getAllRoles = ()=>{
    const url = API_PATH + "/all";
    return axios.get(url);
}

export const createRole = ()=>{
    const url = API_PATH + "/all";
    return axios.get(url);
}